import { Component, ElementRef, OnInit, ViewChild, inject } from '@angular/core';
import { SplashScreenService } from '@core/modules/splash-screen/splash-screen.service';

@Component({
  selector: 'pps-splash-screen',
  templateUrl: './splash-screen.component.html',
  styleUrls: ['./splash-screen.component.scss'],
  standalone: false,
})
export class SplashScreenComponent implements OnInit {
  private readonly _elementRef = inject(ElementRef);
  private readonly _splashScreenService = inject(SplashScreenService);

  @ViewChild('splashScreen', { static: true }) public splashScreen!: ElementRef;

  public ngOnInit(): void {
    this._splashScreenService.init(this._elementRef);
  }
}
